import React from 'react'
import {FormattedMessage, defineMessages} from 'react-intl'
import PropTypes from 'prop-types'
import {Button, Divider, Flex, Text, useStyleConfig} from '@chakra-ui/react'
import {DownloadIcon} from '../../../components/icons/others'
// import {useOrigin} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getLanguage, parseAndSanitizeJSONWithSpaces} from '../../../utils/utils'

const ProductManuals = ({product, productManuals, variant = ''}) => {
    // const appOrigin = useOrigin(false)
    const styles = useStyleConfig('Paperless', {variant})
    const {locale} = useMultiSite()
    const localeId = locale?.id?.split('-')[0]

    const handleLanguage = (language) => {
        if (!language) return
        return `${language.charAt(0).toUpperCase()}${language.slice(1)}`
    }

    const parsedProductManuals =
        product &&
        product?.c_manualDocument &&
        parseAndSanitizeJSONWithSpaces(product?.c_manualDocument, product?.c_subModelIdentifier)

    const manualsToShow = productManuals ? productManuals : parsedProductManuals

    const manualsLabel = defineMessages({
        isIntro: {defaultMessage: 'Intro Manual', id: 'manuals.label.intro'},
        isSafety: {defaultMessage: 'Safety Manual', id: 'manuals.label.safety'},
        isEnergyLabel: {defaultMessage: 'Energy Manual', id: 'manuals.label.energy_label'},
        isIngredient: {defaultMessage: 'Ingredient Manual', id: 'manuals.label.ingredient'},
        isQuickGuide: {defaultMessage: 'Quick Guide', id: 'manuals.label.quick_guide'},
        isProductFiche: {defaultMessage: 'Product Fiche', id: 'manuals.label.product_fiche'},
        isDeclarationOfConformity: {
            defaultMessage: 'Declaration on Conformity',
            id: 'manuals.label.declaration_of_conformity',
        },
        isCoffeeGuide: {defaultMessage: 'Coffee guide', id: 'manuals.label.coffee_guide'},
        default: {defaultMessage: 'Product Manual', id: 'manuals.label.product_manual'},
    })

    const getManualLabelId = (manual) => {
        const knownTypes = Object.keys(manualsLabel)
        return knownTypes.find((key) => manual?.[key] === 'true') || 'default'
    }

    return manualsToShow?.map((manual, i) => (
        <Flex {...styles.productManualsContainer} key={i} data-testid="product-manual-container">
            <Flex {...styles.productManualCard}>
                <Flex gap="xsmall.base">
                    <DownloadIcon {...styles.downloadIcon} />
                    <Flex {...styles.fileFlex}>
                        <Text {...styles.fileLabel}>
                            {variant === 'plpManuals' ? (
                                <FormattedMessage
                                    defaultMessage="{productId} {language}"
                                    id="paperless-page.product-manual-plp-label"
                                    values={{
                                        productId: product?.id,
                                        language: handleLanguage(getLanguage(localeId)),
                                    }}
                                />
                            ) : (
                                <FormattedMessage {...manualsLabel[getManualLabelId(manual)]} />
                            )}
                        </Text>
                    </Flex>
                </Flex>
                {manual?.imageLink && (
                    <Button variant="text-button" onClick={() => window.open(manual.imageLink)}>
                        <FormattedMessage
                            defaultMessage="Download"
                            id="paperless-page.download-label"
                        />
                    </Button>
                )}
            </Flex>
            <Divider {...styles.divider} />
        </Flex>
    ))
}

ProductManuals.propTypes = {
    product: PropTypes.object,
    productManuals: PropTypes.array,
    variant: PropTypes.string,
}

export default ProductManuals
